"use strict";

if (typeof Dropzone != "undefined") {
	Dropzone.autoDiscover = false;
} 

/*****Ready function start*****/
var $wrapper = $(".wrapper");
$(document).ready(function () {
	$wrapper = $(".wrapper");
	InitBootstrap();
	setHeightWidth();
	boxLayout();
	$('.preloader-it > .la-anim-1').addClass('la-animate');
});
/*****Ready function end*****/

/*****Load function start*****/
$(window).on("load",function () {
	$(".preloader-it").delay(500).fadeOut("slow");
	/*Progress Bar Animation*/
	var progressAnim = $('.progress-anim');
	if (progressAnim.length > 0) {
		for (var i = 0; i < progressAnim.length; i++) {
			var $this = $(progressAnim[i]);
			$this.waypoint(function () {
				var progressBar = $(".progress-anim .progress-bar");
				for (var i = 0; i < progressBar.length; i++) {
					$this = $(progressBar[i]);
					$this.css("width", $this.attr("aria-valuenow") + "%");
				}
			}, {
					triggerOnce: true,
					offset: 'bottom-in-view'
				});
		}
	}
});

var setHeightWidth = function () {
	var height = $(window).height();
	var width = $(window).width();
	$('.full-height').css('height', (height));
	$('.page-wrapper').css('min-height', (height));

	/*Right Sidebar Scroll Start*/
	if (width <= 1007) {
		$('.fixed-sidebar-right .set-height-wrap').css('height', (height - 219));

	}
	else {
		$('.fixed-sidebar-right .set-height-wrap').css('height', (height - 153));
	}
	/*Right Sidebar Scroll End*/

	/*Vertical Tab Height Cal Start*/
	var verticalTab = $(".vertical-tab");
	if (verticalTab.length > 0) {
		for (var i = 0; i < verticalTab.length; i++) {
			var $this = $(verticalTab[i]);
			$this.find('ul.nav').css(
				'min-height', ''
			);
			$this.find('.tab-content').css(
				'min-height', ''
			);
			height = $this.find('ul.ver-nav-tab').height();
			$this.find('ul.nav').css(
				'min-height', height + 40
			);
			$this.find('.tab-content').css(
				'min-height', height + 40
			);
		}
	}
	/*Vertical Tab Height Cal End*/
};

var InitBootstrap = function () {
	/*Counter Animation*/
	var counterAnim = $('.counter-anim');
	if (counterAnim.length > 0) {
		counterAnim.counterUp({
			delay: 10,
			time: 1000
		});
	}

	/*Tooltip*/
	if ($('[data-toggle="tooltip"]').length > 0)
		$('[data-toggle="tooltip"]').tooltip();

	/*Popover*/
	if ($('[data-toggle="popover"]').length > 0)
		$('[data-toggle="popover"]').popover();

	/*Sidebar Collapse Animation*/
	var sidebarNavCollapse = $('.fixed-sidebar-left .side-nav  li .collapse');
	var sidebarNavAnchor = '.fixed-sidebar-left .side-nav  li a';
	$(document).on("click", sidebarNavAnchor, function (e) {
		if ($(this).attr('aria-expanded') === "false")
			$(this).trigger("blur");
		$(sidebarNavCollapse).not($(this).parent().parent()).collapse('hide');
	});


	/*Fullscreen Init Js*/
	$(document).on("click", ".full-screen", function (e) {
		$(this).parents('.panel').toggleClass('fullscreen');
		$(window).trigger('resize');
		return false;
	});

	/*Nav Tab Responsive Js*/
	$(document).on('show.bs.tab', '.nav-tabs-responsive [data-toggle="tab"]', function (e) {
		var $target = $(e.target);
		var $tabs = $target.closest('.nav-tabs-responsive');
		var $current = $target.closest('li');
		var $parent = $current.closest('li.dropdown');
		$current = $parent.length > 0 ? $parent : $current;
		var $next = $current.next();
		var $prev = $current.prev();
		$tabs.find('>li').removeClass('next prev');
		$prev.addClass('prev');
		$next.addClass('next');
		return;
	});


	/*Sidebar Navigation*/
	$(document).on('click', '#toggle_nav_btn,#open_right_sidebar,#setting_panel_btn', function (e) {
		$(".dropdown.open > .dropdown-toggle").dropdown("toggle");
		return false;
	});
	$(document).on('click', '#toggle_nav_btn', function (e) {
		$wrapper.removeClass('open-right-sidebar open-setting-panel').toggleClass('slide-nav-toggle');
		if ($wrapper.hasClass('slide-nav-toggle')) {
			localStorage.setItem('toggle_nav_btn_state', "show");
		}
		else {
			localStorage.setItem('toggle_nav_btn_state', "hide");
		}
		return false;
	});

	$(document).on('click', '#open_right_sidebar', function (e) {
		$wrapper.toggleClass('open-right-sidebar').removeClass('open-setting-panel');
		return false;

	});

	$(document).on('click', '#toggle_mobile_nav', function (e) {
		$wrapper.toggleClass('mobile-nav-open').removeClass('open-right-sidebar');
		return;
	});

	if (localStorage != null) {
		var toggle_nav_btn_state = localStorage.getItem('toggle_nav_btn_state');
		if (toggle_nav_btn_state) {
			if (toggle_nav_btn_state === "show") {
				$wrapper.removeClass('open-right-sidebar open-setting-panel').addClass('slide-nav-toggle');
			} else {
				$wrapper.removeClass('open-right-sidebar open-setting-panel').removeClass('slide-nav-toggle');
			}
		}
	}
};

var boxLayout = function () {
	if ((!$wrapper.hasClass("rtl-layout")) && ($wrapper.hasClass("box-layout")))
		$(".box-layout .fixed-sidebar-right").css({ right: $wrapper.offset().left + 300 });
	else if ($wrapper.hasClass("box-layout rtl-layout"))
		$(".box-layout .fixed-sidebar-right").css({ left: $wrapper.offset().left });
};
boxLayout();

/***** Resize function start *****/
$(window).on("resize", function () {
	setHeightWidth();
	boxLayout();
}).trigger("resize");
/***** Resize function end *****/

function partialAddFlash(url, element) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-partial", 1);
		},
		success: function (data, textStatus, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			append(data, element, true, true);
		},
		error: function (data) {
			$('#ModalError > div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}

function partialAddNoScroll(url, element) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-partial", 1);
		},
		success: function (data, textStatus, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			append(data, element, false, false);
		},
		error: function (data) {
			$('#ModalError > div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}

function append(data, element, scroll, flash) {
	var el = $(data).appendTo(element);
	if (flash) {
		var hilight;
		if (el.hasClass("partial")) {
			hilight = el;
		}
		else {
			hilight = el.find('.partial').first();
		}
		if (hilight.length > 0) {
			hilight.addClass('hilight');
			hilight.offset();
			hilight.removeClass('hilight');
		}
	}
	if (scroll) {
		if (el.inView() === false) {
			$('html, body').animate({ scrollTop: el.offset().top + 10000 }, 500, 'linear');
		}
	}
}


function partialAdd(url, element) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-partial", 1);
		},
		success: function (data, textStatus, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			append(data, element, true, false);
		},
		error: function (data) {
			$('#ModalError > div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}


function partialAddWithSuccessCallBack(url, element, callback) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-partial", 1);
		},
		success: function (data, textStatus, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			append(data, element, true, false);
			callback();
		},
		error: function (data) {
			$('#ModalError > div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}

function partialAddWithSuccessCallBackFlash(url, element, callback) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-partial", 1);
		},
		success: function (data, textStatus, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}

			append(data, element, true, true);
			callback();
		},
		error: function (data) {
			$('#ModalError > div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}

function dialogShow(url) {
	$.ajax({
		url: url,
		beforeSend: function (request) {
			request.setRequestHeader("x-dialog", 1);
		},
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			$('#Modal div.content').html(data);
			$('#Modal').modal({ show: true });
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
	return false;
}

function ajaxWithToast(url) {
	$.ajax({
		url: url,
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			toast(data.Heading, data.Message, data.Icon);
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
	return false;
}

function ajaxWithToastButton(button, url) {
	button.addClass("loading");
	$.ajax({
		url: url,
		success: function (data, status, jqXHR) {
			button.removeClass("loading");
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			toast(data.Heading, data.Message, data.Icon);
		},
		error: function (data) {
			button.removeClass("loading");
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });			
		}
	});
	return false;
}

function ajaxWithToastCallBack(url, callback) {
	$.ajax({
		url: url,
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data);
				$('#ModalError').modal({ show: true });
				return;
			}
			toast(data.Heading, data.Message, data.Icon);
			callback();
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
	return false;
}

function processError(xhr, error, code) {
	console.log(xhr);
	console.log(code);
	$('#ModalError div.content').html(error);
	$('#ModalError').modal({ show: true });
}

function processResult(data) {
	if (data === null) {
		$('#ModalError div.content').html("Invalid Response");
		$('#ModalError').modal({ show: true });
		return false;
	}
	if (data.result == 5) {
		$('#ModalError div.content').html("Permission Denied");
		$('#ModalError').modal({ show: true });
		return false;
	}
	if (data.result == 3) {
		$('#ModalError div.content').html("Server Error");
		$('#ModalError').modal({ show: true });
		return false;
	}
	if (data.result == 2) {
		$('#ModalError div.content').html("Data could not be located");
		$('#ModalError').modal({ show: true });
		return false;
	}
	if (data !== null) {
		if (data.toasts !== null) {
			var l = data.toasts.length;
			for (var i = 0; i < l; i++) {
				toast(data.toasts[i].heading, data.toasts[i].message, data.toasts[i].icon);
			}
		}
	}
	return true;
}

function dialogSubmit(form, e) {
	e.preventDefault();
	form = $(form);
	$.ajax({
		type: form.attr('method'),
		url: form.attr('action'),
		beforeSend: function (request) {
			request.setRequestHeader("x-dialog", 1);
			request.setRequestHeader("x-dialogjson", 1);
		},
		data: form.serialize(),
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data.content);
				$('#ModalError').modal({ show: true });
				return;
			}
			if (data !== null) {
				if (data.toasts !== null) {
					var l = data.toasts.length;
					for (var i = 0; i < l; i++) {
						toast(data.toasts[i].heading, data.toasts[i].message, data.toasts[i].icon);
					}
				}
			}
			if (data.close) {
				form.closest('.modal').modal('hide');
				if (data.closeCallback !== "" && data.closeCallback !== "undefined") {
					var str = data.closeCallback.split("(");
					var fnName = str[0];
					var args = str[1].replace(")", "");
					eval(fnName)(args);
				}
				return;
			}
			if (data.hasOwnProperty("redirectUrl"))
			{
				if (data.redirectUrl != "") {
					window.location.href = data.redirectUrl;
					return;
				}
			}
			form.find('.dialog-form-content').html(data.content);
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}



function dialogSubmitWithSpinner(form, e) {
	$('#spinner-div').show();
	e.preventDefault();
	form = $(form);
		$.ajax({
		type: form.attr('method'),
		url: form.attr('action'),
		beforeSend: function (request) {
			request.setRequestHeader("x-dialog", 1);
			request.setRequestHeader("x-dialogjson", 1);
		},
		data: form.serialize(),
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data.content);
				$('#ModalError').modal({ show: true });
				return;
			}
			if (data !== null) {
				if (data.toasts !== null) {
					var l = data.toasts.length;
					for (var i = 0; i < l; i++) {
						toast(data.toasts[i].heading, data.toasts[i].message, data.toasts[i].icon);
					}
				}
			}
			if (data.close) {
				form.closest('.modal').modal('hide');
				if (data.closeCallback !== "" && data.closeCallback !== "undefined") {
					var str = data.closeCallback.split("(");
					var fnName = str[0];
					var args = str[1].replace(")", "");
					eval(fnName)(args);
				}
				return;
			}
			if (data.hasOwnProperty("redirectUrl"))
			{
				if (data.redirectUrl != "") {
					window.location.href = data.redirectUrl;
					return;
				}
			}
			form.find('.dialog-form-content').html(data.content);
		},
		complete: function () {
			$('#spinner-div').hide();
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}


function dialogSearchSubmit(form, e) {
	e.preventDefault();
	form = $(form);
	$.ajax({
		type: form.attr('method'),
		url: form.attr('action'),
		beforeSend: function (request) {
			request.setRequestHeader("x-dialog", 1);
			request.setRequestHeader("x-dialogjson", 1);
		},
		data: form.serialize(),
		success: function (data, status, jqXHR) {
			if (jqXHR.getResponseHeader("x-error") === "true") {
				$('#ModalError div.content').html(data.content);
				$('#ModalError').modal({ show: true });
				return;
			}
			if (data !== null) {
				if (data.toasts !== null) {
					var l = data.toasts.length;
					for (var i = 0; i < l; i++) {
						toast(data.toasts[i].heading, data.toasts[i].message, data.toasts[i].icon);
					}
				}
			}
			if (data.close) {
				form.closest('.modal').modal('hide');
				return;
			}
			if (data.hasOwnProperty("redirectUrl"))
			{
				if (data.redirectUrl != "") {
					window.location.href = data.redirectUrl;
					return;
				}
			}
			form.find('.dialog-form-content').html(data.content);
			form.find('.dialog-result-content').html(data.resultcontent);
		},
		error: function (data) {
			$('#ModalError div.content').html(data);
			$('#ModalError').modal({ show: true });
		}
	});
}

function toast(heading, message, iconType) {
	$.toast({
		heading: heading,
		text: message,
		position: 'top-right',
		loaderBg: '#fec107',
		icon: iconType,
		hideAfter: 3500,
		stack: 6
	});
}


function toastInAndroid(message, backgroundColor, foreColor) {
	CSharp.ShowToast(message, backgroundColor, foreColor);
}

function toastIniOS(heading, message, iconType, absolutePosition) {
	webkit.messageHandlers.callbackHandler.postMessage("toast: " + message);
}

function siteSelect(siteGuid, button) {
	button.closest('.modal').modal('hide');
	window.location.replace("/SiteSelect/" + siteGuid);
}

function companySelect(companyGuid, button) {
	button.closest('.modal').modal('hide');
	window.location.replace("/CompanySelect/" + companyGuid);
}

function siteGroupSelect(siteGroupGuid, button) {
	button.closest('.modal').modal('hide');
	window.location.replace("/SiteGroupSelect/" + siteGroupGuid);
}

function userSelect(userGuid, button) {
	button.closest('.modal').modal('hide');
	window.location.replace("/UserSelect/" + userGuid);
}

function systemSelect(button) {
	button.closest('.modal').modal('hide');
	window.location.replace("/SystemSelect");
}



function IsInteger(val) {
	return !isNaN(val) &&
		parseInt(Number(val)) == val &&
		!isNaN(parseInt(val, 10));
}

function DatePickerCreate(datePicker, inputField) {

	datePicker.Zebra_DatePicker({
		onSelect: function (format, date, jsDate) {
			datePickerDateChanged($(this), inputField, $(this).val(), false);
		},
		onOpen: function () {
			datePickerDateChanged($(this), inputField, datePicker.val(), true);
		}
	});
	datePicker.on('change keyup paste', function () {
		datePickerDateChanged($(this), inputField, $(this).val(), false);
		datePicker.data('Zebra_DatePicker').hide();
	});

	datePicker.siblings(".input-group-addon").on('click', function () {
		if (inputField.is(':disabled') == false) {
			datePicker.data('Zebra_DatePicker').show();
		}
	});
}


function datePickerDateChanged(datePicker, inputField, val, setDate) {
	var m = moment(val, datePickerMomentFormat);
	if (m.isValid()) {
		if (setDate) {
			datePicker.data('Zebra_DatePicker').set_date(m.toDate());
		}
		inputField.val(m.format("YYYY-MM-DD"));
		datePicker.closest(".input-group").removeClass("field-validation-error");
	}
	else {
		inputField.val("");
		datePicker.closest(".input-group").addClass("field-validation-error");
	}
	inputField.trigger('change');
}

function DatePickerCreateV2(datePicker, inputField, dateFormat, momentFormat) {

	datePicker.Zebra_DatePicker({
		format: dateFormat,
		onSelect: function (format, date, jsDate) {
			datePickerDateChangedV2($(this), inputField, $(this).val(), false, momentFormat);
		},
		onOpen: function () {
			datePickerDateChangedV2($(this), inputField, datePicker.val(), true, momentFormat);
		}
	});
	datePicker.on('change keyup paste', function () {
		datePickerDateChanged($(this), inputField, $(this).val(), false);
		datePicker.data('Zebra_DatePicker').hide();
	});

	datePicker.siblings(".input-group-addon").on('click', function () {
		if (inputField.is(':disabled') == false) {
			datePicker.data('Zebra_DatePicker').show();
		}
	});
}

function datePickerDateChangedV2(datePicker, inputField, val, setDate, momentFormat) {
	var m = moment(val, momentFormat);
	if (m.isValid()) {
		if (setDate) {
			datePicker.data('Zebra_DatePicker').set_date(m.toDate());
		}
		inputField.val(m.format("YYYY-MM-DD"));
		datePicker.closest(".input-group").removeClass("field-validation-error");
	}
	else {
		inputField.val("");
		datePicker.closest(".input-group").addClass("field-validation-error");
	}
	inputField.trigger('change');
}


function DatePickerDisable(datePicker, disable) {
	datePicker.prop('disabled', disable);
	datePicker.prev().children('.datepicker').prop('disabled', disable);
}

function TimePickerCreate(el, show12Hour) {
	$(el).timepicker({
		showMeridian: show12Hour
	});
}

function ColorSelectCreate(el) {
	el.on("change", function() { ColorSelect_Changed(el)})
		.trigger('change');
}

function ColorSelect_Changed(el)
{
	var sel = el.find(':selected');
	el.css("color", sel.data("color"));
	el.css("background-color", sel.data("background-color"));	
}

function TextAreaWysiwygCreate(el) {
	tinymce.init({
		selector: el,
		height: 300,
		plugins: [
			'advlist autolink lists link image charmap print preview anchor',
			'searchreplace visualblocks code fullscreen',
			'insertdatetime media table contextmenu paste code'
		],
		paste_data_images: true,
		toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | paste' });
}

$.fn.inView = function () {
	//Window Object
	var win = $(window);
	//Object to Check
	var obj = $(this);
	//the top Scroll Position in the page
	var scrollPosition = win.scrollTop();
	//the end of the visible area in the page, starting from the scroll position
	var visibleArea = win.scrollTop() + win.height();
	//the end of the object to check
	var objEndPos = (obj.offset().top + obj.outerHeight());
	return (visibleArea >= objEndPos && scrollPosition <= objEndPos ? true : false);
};


function FadeOutRemove(el, speed) {
	$(el).fadeOut(speed, function () { $(this).remove(); });
}

function cronSetup(id) {
	$('#' + id).on("input", function () {
		cronUpdate(id);
	});
	cronUpdate(id);
}

function cronUpdate(id) {
	var val = $('#' + id).val();
	var label = $('#' + id + "_description");
	if (val == "") {
		label.html("Disabled");
		label.addClass("error").removeClass("valid");
	}
	else {
		$.ajax({
			url: '/Cron/Description',
			beforeSend: function (jqXHR, settings) {
				jqXHR.setRequestHeader('X-CronPattern', val);
			},
			success: function (data, textStatus, jqXHR) {
				if (data.error) {
					label.html("Error");
					label.addClass("error").removeClass("valid");
				} else if (data.disabled) {
					label.html("Disabled");
					label.removeClass("error").removeClass("valid");
				} else {
					label.html(decodeURIComponent(data.description));
					label.removeClass("error").addClass("valid");
				}
			}
		});
	}
}


function table_child_format(d) {
	return $("tr[data-for='" + d[0] + "']");
}


function table_child_initialise(t) {
	t.rows().every(function () {
		var row = t.row($(this));

		if (typeof row.data() !== 'undefined') {
			var data = table_child_format(row.data());
			row.child(data).show();
		}
	});
}

function Tabs_CheckForErrors() {
	$('[role=tabs] li a[role=tab]').each(function () {
		Tab_CheckForErrors($(this).attr('id'));
	});
}

function Tab_CheckForErrors(tabId) {
	$('#' + tabId + '_content span.field-validation-error').each(function () {
		if ($(this).text != '') {
			$('#' + tabId).parent().addClass('error');
			return false;
		}
	});
}

function Tabs_SelectFirstWithError() {
	$('[role=tabs] li.error a[role=tab]').each(function () {
		$(this).tab('show');
	});
}

function imageUpload_Initialise(id, urlPrefix, updateSize) {
	if ($("#" + id + "_errordisplay").text() == "")
		$("#" + id + "_errordisplay").addClass("collapse");

	$("#" + id + "_Image").on("error",function () {
		$("#" + id + "_Image").addClass("hidden");
		$("#" + id + "_PlaceHolder").removeClass("hidden");
		$("#" + id + "_Remove").addClass("hidden");
	});

	$("#" + id + "_FileUpload").fileupload({
		dataType: "json",
		start: function () {
			$("#" + id + "_Spinner").removeClass("hidden");
		},
		done: function (e, data) {
			var error = data.result.Error;
			if (error != "") {
				$("#" + id + "_errordisplay").text(error);
				$("#" + id + "_Spinner").addClass("hidden");
				$("#" + id + "_errordisplay").collapse("show");
			}
			else {
				var guid = data.result.Guid;
				if (updateSize) {
					$("#" + id + "_Image").css("width", data.result.Width + "px");
					$("#" + id + "_Image").css("height", data.result.Height + "px");
					$("#" + id + "_PlaceHolder").css("width", data.result.Width + "px");
					$("#" + id + "_PlaceHolder").css("height", data.result.Height + "px");
					$("#" + id + "_Spinner").css("width", data.result.Width + "px");
					$("#" + id + "_Spinner").css("height", data.result.Height + "px");
					$("#" + id + "_Container").css("width", data.result.Width + "px");
					$("#" + id + "_Container").css("height", data.result.Height + "px");
					$("#" + id + "_Spinner").css("margin-top", "-" + data.result.Height + "px");
				}
				$("#" + id + "_Image").attr("src", urlPrefix + guid);
				$("#" + id).val(guid);
				$("#" + id + "_errordisplay").collapse("hide");
				$("#" + id + "_PlaceHolder").addClass("hidden");
				$("#" + id + "_Image").removeClass("hidden");
				$("#" + id + "_Remove").removeClass("hidden");
			}
		},
		dropZone: $("." + id + "_dropzone")
	});
}

function imageUpload_RemoveImage(id, urlPrefix, width, height) {
	$("#" + id).val("00000000-0000-0000-0000-000000000000");
	$("#" + id + "_Image").attr("src", urlPrefix + "00000000-0000-0000-0000-000000000000");

	$("#" + id + "_Image").css("width", width + "px");
	$("#" + id + "_Image").css("height", height + "px");
	$("#" + id + "_PlaceHolder").css("width", width + "px");
	$("#" + id + "_PlaceHolder").css("height", height + "px");
	$("#" + id + "_Spinner").css("width", width + "px");
	$("#" + id + "_Spinner").css("height", height + "px");
	$("#" + id + "_Spinner").css("margin-top", "-" + height + "px");
	$("#" + id + "_Container").css("width", width + "px");
	$("#" + id + "_Container").css("height", height + "px");
}

function imageUpload_show(id, show = true)
{
	var container = $(id).closest(".fileUploadContainer"); 
	if (show) {
		$(container).closest(".form-group").show();
	} else {
		$(container).closest(".form-group").hide();
	}
}

function row_enable(id, enable = true) {
	if (enable) {
		$(id).removeAttr('disabled');
		if ($(id).hasClass('hwt-content')) {
			$(id).closest(".hwt-container").removeClass('disabled');
			$(id + "_button").removeAttr('disabled', 'disabled');
		}
		$(id).closest(".form-group").removeClass('disabled');
		$(id).children(".file-input-button").removeClass('disabled');
	} else {
		$(id).attr('disabled', 'disabled');
		if ($(id).hasClass('hwt-content')) {
			$(id).closest(".hwt-container").addClass('disabled');
			$(id + "_button").attr('disabled', 'disabled');
		}
		$(id).closest(".form-group").addClass('disabled');
		$(id).children(".file-input-button").addClass('disabled');
	}
}


function row_show(id, show = true) {
	if (show) {
		$(id).closest(".form-group").show();
	} else {
		$(id).closest(".form-group").hide();
	}
}

function row_disable(id) {
	row_enable(id, false);
}

$(document).on('shown.bs.modal', function() {
	var items = $(this).find('[autofocus]');
	items.trigger("focus");
});



function ColorPicker_Create(id) {
	$(id).colorpicker({
		});
}

$.fn.insertIntoTextArea = function(textToInsert) {
	return this.each(function () {
		var txt = $(this);
		var cursorPosStart = txt.prop('selectionStart');
		var cursorPosEnd = txt.prop('selectionEnd');
		var v = txt.val();
		var textBefore = v.substring(0,  cursorPosStart);
		var textAfter  = v.substring(cursorPosEnd, v.length);
		txt.val(textBefore + textToInsert + textAfter);
		txt.prop('selectionStart', cursorPosStart);
		txt.prop('selectionEnd', cursorPosStart + textToInsert.length);
		txt.trigger("focus");
	});
}

function throbber_Show()
{
	$("body > .overlay").removeClass("d-none");
	$("body > .throbber").removeClass("d-none");
}

function throbber_Hide()
{
	$("body > .overlay").addClass("d-none");
	$("body > .throbber").addClass("d-none");
}


function PhoneInputCreate(phoneInputSelector, valueFieldSelector, initialValue) {

	const input = document.querySelector(phoneInputSelector);
	const iti = window.intlTelInput(input, {
		loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
		initialCountry: "auto",
		geoIpLookup: function (callback) {
			fetch('https://ipapi.co/json')
				.then(response => response.json())
				.then(data => callback(data.country_code))
				.catch(() => callback('us'));
			},
		});

		if (initialValue) {
			iti.setNumber(initialValue);
		}

		$(phoneInputSelector).closest('form').on("submit", function (e) {
			$(valueFieldSelector).val(iti.getNumber());
		});
}

function PhoneInputCreate_Dialog(phoneInputSelector, valueFieldSelector, initialValue) {

	const input = document.querySelector(phoneInputSelector);
	const iti = window.intlTelInput(input, {
		loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
		initialCountry: "auto",
		geoIpLookup: function (callback) {
			fetch('https://ipapi.co/json')
				.then(response => response.json())
				.then(data => callback(data.country_code))
				.catch(() => callback('us'));
			},
		});

		if (initialValue) {
			iti.setNumber(initialValue);
		}

		dialogBeforeSubmitHandlers.push(function () {
			$(valueFieldSelector).val(iti.getNumber());
		});
}

